import { useState, useEffect } from "react"
import { Link, useLocation, useNavigate } from "react-router-dom"
import {Menu, X} from 'lucide-react'

const LOGO_URL = "https://static.lumi.new/c0/c0161516f46a51231baabd52ffafbe61.png"

const navLinks = [
  { label: "Quem Somos", sectionId: "quem-somos" },
  { label: "Nosso Propósito", sectionId: "proposito" },
  { label: "Lucy I.A", sectionId: "lucy-ia" },
  { label: "Cursos", sectionId: "cursos" },
  { label: "Para Quem", sectionId: "para-quem" },
  { label: "Nossa Visão", sectionId: "visao" },
]

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  const location = useLocation()
  const navigate = useNavigate()
  const isHome = location.pathname === "/"

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60)
    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  useEffect(() => {
    setMenuOpen(false)
  }, [location])

  const scrollToSection = (sectionId: string) => {
    setMenuOpen(false)
    if (!isHome) {
      navigate("/")
      setTimeout(() => {
        const el = document.getElementById(sectionId)
        el?.scrollIntoView({ behavior: "smooth", block: "start" })
      }, 300)
    } else {
      const el = document.getElementById(sectionId)
      el?.scrollIntoView({ behavior: "smooth", block: "start" })
    }
  }

  const showSolid = scrolled || !isHome

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 ${
        showSolid ? "bg-white shadow-lg py-2" : "py-3"
      }`}
      style={!showSolid ? { backgroundColor: "#0E8EA0" } : {}}
    >
      <div className="max-w-7xl mx-auto px-5 flex items-center justify-between">
        <button
          onClick={() => { setMenuOpen(false); window.scrollTo({ top: 0, behavior: "smooth" }); if (!isHome) navigate("/"); }}
          className="flex items-center bg-transparent border-none cursor-pointer p-0"
        >
          <img
            src={LOGO_URL}
            alt="English Work"
            className="h-10 md:h-12 w-auto object-contain transition-all duration-300"
          />
        </button>

        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center gap-6">
          {navLinks.map((link) => (
            <button
              key={link.sectionId}
              onClick={() => scrollToSection(link.sectionId)}
              className={`text-sm font-semibold tracking-wide transition-colors duration-300 bg-transparent border-none cursor-pointer ${
                showSolid
                  ? "text-gray-600 hover:text-[#0E8EA0]"
                  : "text-white/90 hover:text-white"
              }`}
            >
              {link.label}
            </button>
          ))}

          <a
            href="https://www.ewpass.com.br"
            target="_blank"
            rel="noopener noreferrer"
            className="ml-2 px-6 py-2.5 text-sm font-bold rounded-full transition-all duration-300 cursor-pointer border-none no-underline inline-block"
            style={
              showSolid
                ? { backgroundColor: "#B038B2", color: "#fff" }
                : { backgroundColor: "#fff", color: "#0E8EA0" }
            }
          >
            Conheça o EW Pass
          </a>
        </div>

        {/* Mobile Toggle */}
        <button
          onClick={() => setMenuOpen(!menuOpen)}
          className={`lg:hidden ${showSolid ? "text-gray-700" : "text-white"}`}
        >
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      <div
        className={`lg:hidden absolute top-full left-0 right-0 bg-white shadow-xl transition-all duration-300 overflow-y-auto ${
          menuOpen ? "max-h-[80vh] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="px-5 py-5 flex flex-col gap-1">
          {navLinks.map((link) => (
            <button
              key={link.sectionId}
              onClick={() => scrollToSection(link.sectionId)}
              className="text-gray-700 font-semibold text-sm py-3 px-3 rounded-lg hover:bg-gray-50 transition-colors text-left bg-transparent border-none cursor-pointer"
            >
              {link.label}
            </button>
          ))}
          <a
            href="https://www.ewpass.com.br"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 px-5 py-3 text-white text-sm font-bold rounded-full text-center cursor-pointer border-none no-underline block"
            style={{ backgroundColor: "#B038B2" }}
          >
            Conheça o EW Pass
          </a>
        </div>
      </div>
    </nav>
  )
}
